module.exports = __webpack_public_path__ + "static/media/Cross.158a8980.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Icons/Cross.svg
// module id = 54
// module chunks = 0